export default __webpack_public_path__ + "avidemux.d076850e.png";